import * as React from 'react';
import { Input } from '@/components/forms/ui/input';

type TextFieldProps = {
  id: string;
  label: string;
  value: string | undefined;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  description?: string;
  error?: string;
};

export function TextField({
  id,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  description,
  error
}: TextFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
      </label>
      {description ? <span className="text-muted-foreground text-xs">{description}</span> : null}
      <Input
        id={id}
        value={value ?? ''}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        aria-invalid={error ? true : undefined}
      />
      {error ? <span className="text-destructive text-sm">{error}</span> : null}
    </div>
  );
}
